import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TaskTypeListLayer from "../components/TaskTypeListLayer";

const TaskTypePage = () => {
  return (
    <>
      <MasterLayout pageTitle="Task Types">
        <TaskTypeListLayer />
      </MasterLayout>
    </>
  );
};

export default TaskTypePage;
